<template>
  <b-modal id="changeClientModal" @ok="onOk" body-class="p-0" title="Cambiar de cliente">
    <b-form>
      <b-form-select v-model="selected" :options="options"> </b-form-select>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: "ChangeClient",
  data() {
    return {
      loading: false,
      options: [
        { value: 4, text: "Alfaberries" },
        { value: 3, text: "Mondasol" },
        { value: 11, text: "Bluefields" },
        { value: 2, text: "Alejandro SA" },
        { value: 1, text: "Pearson Hall" },
        { value: 15, text: "Imperial" }
      ],
      selected: null
    };
  },
  mounted() {
    this.selected = this.$store.state.user.ID_CLIENTE;
  },
  methods: {
    onShow() {
      return;
    },
    async onOk() {
      this.loading = true;
      try {
        const res = await this.$axios.post("/menu_app/change_client/" + this.selected + "/");
        this.$bvToast.toast(res.data.message, {
          title: "Éxito",
          variant: "success",
          solid: true
        });
        window.location.reload();
      } catch (error) {
        this.$bvToast.toast(error.response.data.message, {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
